module.exports = __webpack_public_path__ + "static/media/Cecilie.8d95d140.webp";